import { useLayoutEffect, useRef } from 'react';

// info: dataAttributeKey is the data attribute key of the accordion that we want to maintain scroll for
// info: this hook is used to maintain scroll for a list of accordions
// also it's better to Add scroll margin to provide spacing when scrolling into view to the accordion item : search for `Add scroll margin to provide spacing when scrolling into view` to find the expample of this
export function useMaintainScrollForListOfAccordions(
  dataAttributeKey: string,
  selectedItem?: string
) {
  const containerRef = useRef<HTMLDivElement>(null);
  const previousCurrentRef = useRef<string | undefined>(undefined);

  // Simple solution: When switching accordions, always scroll the new one into view
  useLayoutEffect(() => {
    // Only act when switching between accordions (not when closing or first opening)
    const isSwitching =
      previousCurrentRef.current !== undefined &&
      previousCurrentRef.current !== selectedItem &&
      selectedItem !== undefined;

    if (isSwitching && selectedItem) {
      // Wait for DOM to update after accordion expansion
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const currentElement = containerRef.current?.querySelector(
            `[${dataAttributeKey}="${selectedItem}"]`
          );

          if (currentElement) {
            // Always scroll into view when switching - this prevents jump issues
            currentElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        });
      });
    }

    previousCurrentRef.current = selectedItem;
  }, [selectedItem, dataAttributeKey]);

  return containerRef;
}
